/**
 * @generated SignedSource<<5d776fd041864b792fd4f09afe8f45e6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ReceiverStoresSelectorListItem_receiverStore$data = {
  readonly routedTeams: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"ReceiverStoresSelectorTeamsIndicator_teams">;
  } | null> | null;
  readonly store: {
    readonly " $fragmentSpreads": FragmentRefs<"ReceiverStoresSelectorMain_receiverStore">;
  };
  readonly " $fragmentType": "ReceiverStoresSelectorListItem_receiverStore";
};
export type ReceiverStoresSelectorListItem_receiverStore$key = {
  readonly " $data"?: ReceiverStoresSelectorListItem_receiverStore$data;
  readonly " $fragmentSpreads": FragmentRefs<"ReceiverStoresSelectorListItem_receiverStore">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ReceiverStoresSelectorListItem_receiverStore",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Store",
      "kind": "LinkedField",
      "name": "store",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ReceiverStoresSelectorMain_receiverStore"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "routedTeams",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ReceiverStoresSelectorTeamsIndicator_teams"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ReceiverStore",
  "abstractKey": null
};

(node as any).hash = "58deba7b58385b0f72c8fbfac271bcf7";

export default node;
